const BASE_URL = process.env.REACT_APP_API_BASE_URL || 'http://localhost:8081/isoret-rs/api';

class ApiClient {
  async request(endpoint, options = {}) {
    const url = `${BASE_URL}${endpoint}`;

    const token = localStorage.getItem('token') || sessionStorage.getItem('token');
    const headers = {
      'Content-Type': 'application/json',
      ...options.headers,
    };

    if (token && !options.skipAuth) {
      headers['Authorization'] = `Bearer ${token}`;
    }

    const config = {
      ...options,
      headers,
    };

    if (config.body && typeof config.body === 'object') {
      config.body = JSON.stringify(config.body);
    }

    try {
      const response = await fetch(url, config);

      const text = await response.text();
      let data = null;
      try {
        data = text ? JSON.parse(text) : null;
      } catch {
        data = text;
      }

      if (!response.ok) {
        let errorMsg = 'Something went wrong';
        if (typeof data === 'string' && data.trim()) {
          errorMsg = data.trim();
        } else if (data && typeof data === 'object') {
          errorMsg =
            data.message ||
            data.error ||
            data.errorMessage ||
            (typeof data.data === 'string' ? data.data : '') ||
            text ||
            'Something went wrong';
        } else if (text && text.trim()) {
          errorMsg = text.trim();
        }

        throw {
          status: response.status,
          message: errorMsg,
          data,
        };
      }

      return data;
    } catch (error) {
      if (error.status) {
        throw error;
      }
      throw {
        status: 500,
        message: error.message || 'Network connectivity error',
      };
    }
  }

  get(endpoint, options = {}) {
    return this.request(endpoint, { ...options, method: 'GET' });
  }

  post(endpoint, body, options = {}) {
    return this.request(endpoint, { ...options, method: 'POST', body });
  }

  put(endpoint, body, options = {}) {
    return this.request(endpoint, { ...options, method: 'PUT', body });
  }

  delete(endpoint, options = {}) {
    return this.request(endpoint, { ...options, method: 'DELETE' });
  }
}

export const apiClient = new ApiClient();
